/**
 * Enum-like constants that span both API + web. Keep this file framework-free
 * (no imports beyond zod) so it can be consumed from any package.
 */

export const TRADES = [
  'HVAC',
  'Plumbing',
  'Electrical',
  'General',
] as const;

export type Trade = (typeof TRADES)[number];
